import React, { useState } from 'react';
import './BalloonTooltip.scss';

const BalloonTooltip = ({ 
  children, 
  content, 
  position = 'top',
  trigger = 'hover',
  className = '',
  maxWidth = '200px'
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (trigger === 'hover') {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (trigger === 'hover') {
      setIsVisible(false);
    }
  };

  const handleClick = () => {
    if (trigger === 'click') {
      setIsVisible(!isVisible);
    }
  };

  const formatContent = (content) => {
    if (!content) return 'Nenhuma informação disponível';
    
    if (typeof content === 'object') {
      const { motivo, outros_motivos } = content;
      let text = '';
      
      if (motivo) {
        text += `Motivo: ${motivo}`;
      }
      
      if (outros_motivos) {
        if (text) text += '\n';
        text += `Outros motivos: ${outros_motivos}`;
      }
      
      return text || 'Nenhuma informação disponível';
    }
    
    return content;
  };

  return (
    <div 
      className={`balloon-tooltip-container ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      style={{ cursor: 'help' }}
    >
      {children}
      {isVisible && (
        <div 
          className={`balloon-tooltip balloon-tooltip-${position}`}
          style={{ maxWidth }}
        >
          <div className="balloon-content">
            {formatContent(content).split('\n').map((line, index) => (
                <div key={index}>{line}</div>
            ))}
          </div>
          <div className="balloon-arrow"></div>
        </div>
      )}
    </div>
  );
};

export default BalloonTooltip;
